<template>
    <div class="cart">
        <!--Top Bar-->
        <TopBar msg="Welcome to Your Vue.js App" />
        <!--Top Bar-->

        <v-divider></v-divider>

        <v-card elevation="0"
            class="bg-secondary mx-auto rounded-xl mt-n6 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none "
            height="120">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="mobile-category-title-text">
                    Orders
                </h1>
            </div>
        </v-card>

        <!--<v-container>-->
        <v-row dense class="bg-white">
            <v-col cols="12" sm="12" md="12">

                <v-card class="mx-auto bg-white" elevation="0" min-height="500" max-width="1100">
                    <div class="d-flex flex-column text-left text-black ml-2">
                        <h1
                            class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block  font-weight-bold mt-4 ml-4">
                            Orders
                        </h1>

                    </div>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-card class="ma-4 rounded-xl pa-5" elevation="0" variant="outlined" color="#b8b8b8" dark>
                                <v-text-field v-model="ordersearch" append-icon="mdi-magnify" label="Search" single-line
                                    hide-details class="mb-5"></v-text-field>

                                <!--Web View-->
                                <v-data-table v-model:items-per-page="itemsPerPage" :headers="headers" :items="getOrders"
                                    :search="ordersearch" item-value="id"
                                    class="elevation-0 d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                                    <template v-slot:[`item.order_code`]="{ item }">
                                        <v-btn color="primary" variant="outlined" size="small" min-height="30"
                                            @click="viewItem(item)">
                                            <p class="text-black">{{ item.order_code }}</p>
                                        </v-btn>
                                    </template>

                                    <template v-slot:[`item.zoho_invoice_id`]="{ item }">
                                        <v-btn color="primary" variant="flat" size="small"  min-height="30" @click="downloadInvoice(item.id)"  v-if="item.zoho_invoice_id != null"><span class="zoho-button"> Zoho Invoice</span></v-btn>
                                    </template>

                                </v-data-table>
                                <!--web View end-->

                                <!--Mobile View-->
                                <v-data-table v-model:items-per-page="itemsPerPage" :headers="mobheaders" :items="getOrders"
                                    :search="ordersearch" item-value="id"
                                    class="elevation-0 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mobile-datatable">
                                    <template v-slot:[`item.order_code`]="{ item }">
                                        <v-btn color="primary" variant="outlined" size="x-small" min-height="30"
                                            @click="viewItem(item)">
                                            <p class="text-black">{{ item.order_code }}</p>
                                        </v-btn>
                                    </template>

                                    <template v-slot:[`item.zoho_invoice_id`]="{ item }">
                                        <v-btn color="primary" class="zoho-button-mob" variant="flat" size="x-small" min-height="10" @click="downloadInvoice(item.id)"   v-if="item.zoho_invoice_id != null" ><span class="zoho-button"><v-icon icon="mdi-download"></v-icon></span></v-btn>
                                    </template>

                                </v-data-table>
                                <!--Mobile View End-->

                            </v-card>

                        </v-col>

                    </v-row>
                </v-card>
            </v-col>

        </v-row>
        <!--</v-container>-->

        <AppFooter />

        <v-dialog v-model="orderDetaildialog" width="auto">

            <!--Web View-->
            <v-card class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                <v-toolbar dark color="primary">
                    <v-card-title class="text-h5 text-white font-weight-bold mt-4">{{
                        getOrderDetails.order_code }} - {{
        getOrderDetails.currentstatus }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="orderDetaildialog = false" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>

                    <v-table>
                        <thead>
                            <tr v-if="getOrderDetails.zoho_invoice_id != null">
                                <th colspan="5" class="text-right">
                                    <v-btn color="primary" variant="flat" size="small"  min-height="30" @click="downloadInvoice(item.id)"  v-if="getOrderDetails.zoho_invoice_id != null"><span class="zoho-button"> Zoho Invoice</span></v-btn>
                                </th>
                            </tr>
                            <tr>
                                <th class="text-left"></th>
                                <th class="text-center">Name</th>
                                <th class="text-center">Qty</th>
                                <th class="text-center">Ord Price</th>
                                <th class="text-center" v-if="getOrderDetails.deliveredprice > 0">
                                    Del Price
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in getOrderDetails.itemlist" :key="item.product_name">
                                <td>
                                    <v-avatar class="ma-3" size="65" rounded="0">
                                        <v-img :src="item.product_image"></v-img>
                                    </v-avatar>
                                </td>
                                <td>
                                    <div class="text-subtitle-1 text-black font-weight-bold text-wrap text-left">
                                        {{ item.product_name }} - {{ item.unit_name }}
                                    </div> <v-btn variant="text" min-height="30" class="text-left">
                                        <p class="text-primary price-text text-subtitle-1 font-weight-bold">
                                            Rs.{{ item.base_price }}</p>
                                    </v-btn>
                                </td>
                                <td>
                                    <div class="text-subtitle-1 text-black font-weight-bold text-wrap text-left">
                                        {{ item.order_qty }}
                                    </div>
                                </td>
                                <td>
                                    <v-card-title class="text-subtitle-1 text-black font-weight-bold">
                                        Rs.{{ item.order_price }}
                                    </v-card-title>
                                </td>
                                <td v-if="getOrderDetails.deliveredprice > 0">
                                    <v-card-title class="text-subtitle-1 text-black font-weight-bold">
                                        Rs.{{ item.delivery_price }}
                                    </v-card-title>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th class="text-left"></th>
                                <th class="text-left"></th>
                                <th class="text-left"></th>
                                <th class="text-left">
                                    <v-card-title class="text-subtitle-1 text-black font-weight-bold">Rs.{{
                                        getOrderDetails.total_amount }}</v-card-title>
                                </th>
                                <th class="text-left" v-if="getOrderDetails.deliveredprice > 0">
                                    <v-card-title class="text-subtitle-1 text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.deliveredprice }}</v-card-title>
                                </th>
                            </tr>
                            <tr>
                                <template v-if="getOrderDetails.deliveredprice > 0">
                                    <th class="text-right" colspan="4" >Shipping Charge</th>
                                </template>
                                <template v-else>
                                    <th class="text-right" colspan="3" >Shipping Charge</th>
                                </template>
                                
                                <th class="text-left" >
                                    <v-card-title class="text-subtitle-1 text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.delivery_charge }}</v-card-title>
                                </th>
                            </tr>
                            <tr>
                                <template v-if="getOrderDetails.deliveredprice > 0">
                                    <th class="text-right" colspan="4" >Miscellaneous amount</th>
                                </template>
                                <template v-else>
                                    <th class="text-right" colspan="3" >Miscellaneous amount</th>
                                </template>
                                
                                <th class="text-left" >
                                    <v-card-title class="text-subtitle-1 text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.miscellaneous_amount }}</v-card-title>
                                </th>
                            </tr>
                            <tr>
                                <template v-if="getOrderDetails.deliveredprice > 0">
                                    <th class="text-right" colspan="4" >
                                        Total amount
                                    </th>
                                </template>
                                <template v-else>
                                    <th class="text-right" colspan="3" >Total amount</th>
                                </template>
                                
                                <th class="text-left" >
                                    <v-card-title class="text-subtitle-1 text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.overalltotal }}</v-card-title>
                                </th>
                            </tr>
                        </tfoot>
                    </v-table>
                </v-card-text>
            </v-card>
            <!--Web View End-->

            <!--Mobile View-->
            <v-card class="d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none">
                <v-toolbar dark color="primary">
                    <v-card-title class="text-white font-weight-bold mt-4">{{
                        getOrderDetails.order_code }} - {{
        getOrderDetails.currentstatus }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="orderDetaildialog = false" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-table class="mobile-card-text">
                        <thead>
                            <tr v-if="getOrderDetails.zoho_invoice_id != null">
                                <th colspan="5" class="text-left">
                                    <v-btn color="primary" variant="flat" size="small"  min-height="30" @click="downloadInvoice(item.id)"  v-if="getOrderDetails.zoho_invoice_id != null"><span class="zoho-button"> Zoho Invoice</span></v-btn>
                                </th>
                            </tr>
                            <tr>
                                <th class="text-left"></th>
                                <th class="text-center ">Name</th>
                                <th class="text-center">Qty</th>
                                <th class="text-center">Ord Price</th>
                                <th class="text-center" v-if="getOrderDetails.deliveredprice > 0">
                                    Del Price
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in getOrderDetails.itemlist" :key="item.product_name">
                                <td>
                                    <v-avatar class="ma-3" size="40" rounded="0">
                                        <v-img :src="item.product_image"></v-img>
                                    </v-avatar>
                                </td>
                                <td>
                                    <div class="mobile-card-text text-black font-weight-bold text-wrap text-left">
                                        {{ item.product_name }} - {{ item.unit_name }}
                                    </div> <v-btn variant="text" min-height="30" class="text-left">
                                        <p class="text-primary price-text mobile-card-text font-weight-bold">
                                            Rs.{{ item.base_price }}</p>
                                    </v-btn>
                                </td>
                                <td>
                                    <div class="mobile-card-text text-black font-weight-bold text-wrap text-left">
                                        {{ item.order_qty }}
                                    </div>
                                </td>
                                <td>
                                    <v-card-title class="mobile-card-text text-black font-weight-bold">
                                        Rs.{{ item.order_price }}
                                    </v-card-title>
                                </td>
                                <td v-if="getOrderDetails.deliveredprice > 0">
                                    <v-card-title class="mobile-card-text text-black font-weight-bold">
                                        Rs.{{ item.delivery_price }}
                                    </v-card-title>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th class="text-left"></th>
                                <th class="text-left"></th>
                                <th class="text-left"></th>
                                <th class="text-left">
                                    <v-card-title class="mobile-card-text text-black font-weight-bold">Rs.{{
                                        getOrderDetails.total_amount }}</v-card-title>
                                </th>
                                <th class="text-left" v-if="getOrderDetails.deliveredprice > 0">
                                    <v-card-title class="mobile-card-text text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.deliveredprice }}</v-card-title>
                                </th>
                            </tr>
                            <tr>
                                <template v-if="getOrderDetails.deliveredprice > 0">
                                    <th class="mobile-card-text text-right" colspan="4" >Shipping Charge</th>
                                </template>
                                <template v-else>
                                    <th class="mobile-card-text text-right" colspan="3" >Shipping Charge</th>
                                </template>
                                
                                <th class="text-left" >
                                    <v-card-title class="mobile-card-text text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.delivery_charge }}</v-card-title>
                                </th>
                            </tr>
                            <tr>
                                <template v-if="getOrderDetails.deliveredprice > 0">
                                    <th class="mobile-card-text text-right" colspan="4" >Miscellaneous amount</th>
                                </template>
                                <template v-else>
                                    <th class="mobile-card-text text-right" colspan="3" >Miscellaneous amount</th>
                                </template>
                                
                                <th class="text-left" >
                                    <v-card-title class="mobile-card-text text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.miscellaneous_amount }}</v-card-title>
                                </th>
                            </tr>
                            <tr>
                                <template v-if="getOrderDetails.deliveredprice > 0">
                                    <th class="mobile-card-text text-right" colspan="4" >Total amount</th>
                                </template>
                                <template v-else>
                                    <th class="mobile-card-text text-right" colspan="3" >Total amount</th>
                                </template>
                                
                                <th class="text-left" >
                                    <v-card-title class="mobile-card-text text-black font-weight-bold"> Rs.{{
                                        getOrderDetails.overalltotal }}</v-card-title>
                                </th>
                            </tr>
                        </tfoot>
                    </v-table>
                </v-card-text>
            </v-card>
            <!--Mobile View End-->


        </v-dialog>
    </div>
</template>
  

<style>
.cart-btn {
    letter-spacing: 0px !important;
    font-size: 14px !important;
    height: 48px !important;
}

.mobile-datatable {
    font-size: 12px !important;
}

.mobile-card-text {
    font-size: 12px !important;
}

.zoho-button{
    color: white;
}

.zoho-button-mob{
    font-size: 10px;
    color: #fff;
}
</style>

<script >
// @ is an alias to /src

import TopBar from '@/components/Bar.vue'

import AppFooter from '@/components/Footer.vue'
import { VUE_WEB_BASEURL } from "../utils/api";

import { mapActions, mapGetters } from "vuex";
import { VDataTable } from "vuetify/components/VDataTable";
export default {
    name: 'OrderView',
    data: () => ({
        itemsPerPage: 10,
        ordersearch: '',
        headers: [
            {
                title: 'Order',
                align: 'center',
                sortable: false,
                key: 'order_code',
            },
            { title: 'Price', align: 'center', key: 'overalltotal' },
            { title: 'Date', align: 'center', key: 'orderdate' },
            { title: 'Status', align: 'center', key: 'current_status' },
            {
                title: 'Invoice',
                align: 'center',
                sortable: false,
                key: 'zoho_invoice_id',
            },
            // { title: 'Actions', align: 'center', key: 'actions', sortable: false },
        ],
        mobheaders: [
            {
                title: 'Order',
                align: 'center',
                sortable: false,
                key: 'order_code',
            },
            // { title: 'Price', align: 'center', key: 'overalltotal' },
            { title: 'Date', align: 'center', key: 'orderdate' },
            { title: 'Status', align: 'center', key: 'current_status' },
            { title: 'Inv', align: 'center', key: 'zoho_invoice_id' },
        ],
        orderDetaildialog: false,
    }),

    components: {
        TopBar,
        AppFooter,
        VDataTable,
    },
    computed: {
        ...mapGetters([
            "getLoginStatus",
            "getOrders",
            "getLoginResponse",
            "getOrderDetails",
        ]),

        loginStatusmsg: function () {
            return this.getLoginStatus === "error";
        },
        loginStatusResponse: function () {
            return this.getLoginResponse;
        }
    },
    created() {
        this.orders();
    },
    methods: {
        ...mapActions(["orders", "orderDetails"]),
        viewItem(item) {
            //console.log(item.key);
            this.orderDetails(item.id);
            this.orderDetaildialog = true;
        },
        downloadInvoice(id){
            window.open(VUE_WEB_BASEURL+'invoiceexport/'+id, '_blank')
        }
    }
}
</script>
